import React from "react";
import clsx from "clsx";

import IconContainer from "../IconContainer";
import * as twitterStyles from "../../../styles/widgets/twitter.module.scss";

const Twitter = ({tweet}) => {
    const tweetItem = {};

    tweetItem.id = tweet?.retweet ? tweet?.retweetIdStringFormat : tweet?.idStringFormat;

    tweetItem.userName = tweet?.retweet ? tweet?.retweetedStatus?.user?.name : tweet?.user?.name;

    tweetItem.userScreenName = tweet?.retweet ? tweet?.retweetedStatus?.user?.screenName : tweet?.user?.screenName;

    tweetItem.tweetText = tweet?.text
        .replace(tweet?.text.match(/https:\/\/t\.co\/\S+\s*$/g), "")
        .replace(tweet?.text.match(/RT @\S+ /g), "");
    return (<>
        <>
            <div className={twitterStyles.bloc}>
                <div className={twitterStyles.innerBloc}>
                    <button
                        className={twitterStyles.itemBloc}
                        rel="noreferrer"
                        aria-label={tweetItem.userName + ' @' + tweetItem.userScreenName + ' ' + tweetItem.tweetText}
                        onClick={() => typeof window !== `undefined` && window.open(`https://twitter.com/${tweetItem.userScreenName}/status/${tweetItem.id}`, "_blank")}
                        onKeyDown={() => typeof window !== `undefined` && window.open(`https://twitter.com/${tweetItem.userScreenName}/status/${tweetItem.id}`, "_blank")}
                    >
                        {tweet?.retweet && (<div className={twitterStyles.containerRetweet}>
                            <IconContainer
                                icon={"TWITTER_RETWEET"}
                                classname={twitterStyles.logoRetweet}
                                size="20"
                            />
                            <p
                                className={clsx(twitterStyles.retweet, twitterStyles.nbLinesTop)}
                            >
                                {tweet?.user?.name} a retweeté
                            </p>
                        </div>)}
                        <div className={twitterStyles.containerContent}>
                            <div
                                className={twitterStyles.content}
                            >
                                <p
                                    className={clsx(twitterStyles.screenName, twitterStyles.nbLinesTop)}
                                >
                                    {tweetItem.userName}
                                </p>
                                <IconContainer
                                    icon={"TWITTER"}
                                    classname={twitterStyles.logo}
                                    size={30}
                                />
                                <div className={twitterStyles.contentId}>
                                    <p
                                        className={twitterStyles.id}
                                    >
                                        @{tweetItem.userScreenName}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={twitterStyles.contentHashtag}>
                            <p
                                className={clsx(twitterStyles.text, twitterStyles.nbLines)}
                            >
                                {tweetItem.tweetText}
                            </p>
                            {tweet?.hashtagEntities.map((hashtag, index) => (<p
                                key={index}
                                className={twitterStyles.hashtag}
                            >
                                #{hashtag.text}&nbsp;
                            </p>))}
                        </div>
                    </button>
                </div>
            </div>
        </>
    </>);
};

export default Twitter;
